import { useState, useEffect } from 'react';
// Clerk normally finishes loading in a second or two; give it a generous window so a
// slow-but-working connection isn't mistaken for a block before flagging.
// this is also the boot-splash deadline (see App.tsx)
export const CLERK_LOAD_TIMEOUT_MS = 12000;
const isClerkConfigured = typeof window !== 'undefined'
    && !!(process.env.REACT_APP_CLERK_PUBLISHABLE_KEY || process.env.CLERK_PUBLISHABLE_KEY);
/**
 * Detects when the Clerk auth service fails to load — typically because a corporate/school
 * proxy or web filter blocks Clerk's CDN, so the browser gets an HTML block page instead of
 * clerk.browser.js ("Unexpected token '<'" / failed to load clerk.js timeout). When that
 * happens getClerkToken() returns null, and every API call 401s and silently falls back to
 * local cache. This lets us tell the user *why* rather than presenting it as an ordinary
 * signed-out session.
 *
 * clerk-js sets window.Clerk once its script actually runs — and does so whether or not a
 * user is signed in. So a missing window.Clerk after a generous timeout means the script
 * never loaded (blocked), which is a different state from "loaded but signed out". We can't
 * key off clerk-react's isLoaded here: when the script is blocked, clerk-react hits its own
 * load timeout and flips isLoaded to true (giving up), so that flag ends up identical to a
 * healthy load. window.Clerk is the same signa getClerkToken() itself relies on.
 */
export function useAuthServiceBlocked(online) {
    const [blocked, setBlocked] = useState(false);
    useEffect(() => {
        if (!isClerkConfigured)
            return;
        const id = window.setTimeout(() => {
            const loaded = !!window.Clerk;
            if (!loaded)
                setBlocked(true);
        }, CLERK_LOAD_TIMEOUT_MS);
        return () => window.clearTimeout(id);
    }, []);
    // Only flag while online: offline legitimately leaves Clerk unloaded and is already
    // covered by the offline banner.
    return isClerkConfigured && blocked && online;
}
